import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { convertIpfsUrlToGatewayUrl, getRemoteUrlContent } from '../../utils/ipfs'

export default function NftCard({ info: token, onOpen }) {
    const { t } = useTranslation()
    const [metadata, setMetadata] = useState({})
    const [mediaType, setMediaType] = useState('image')
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        let active = true
        setLoading(true)
        setError('')
        setMediaType('image')
        getRemoteUrlContent(token.url)
            .then((content) => {
                if (!active) return
                const parsed = JSON.parse(content)
                setMetadata({
                    ...parsed,
                    image: convertIpfsUrlToGatewayUrl(parsed.image || ''),
                })
            })
            .catch((fetchError) => {
                if (!active) return
                console.error('Unable to load NFT metadata', fetchError)
                setError(fetchError?.message || t('NFT元数据加载失败'))
            })
            .finally(() => active && setLoading(false))
        return () => { active = false }
    }, [t, token.url])

    const openDetails = () => onOpen?.({ token, metadata, mediaType })

    return <article className="nft-card" role="button" tabIndex="0" aria-label={`${metadata.name || 'NFT'} #${token.id}`} onClick={openDetails} onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            openDetails()
        }
    }}>
        <div className="nft-card__media">
            {loading && <div className="nft-card__state"><i className="fa fa-spinner loading-css" /><span>{t('读取元数据')}</span></div>}
            {!loading && error && <div className="nft-card__state is-error"><i className="fa fa-exclamation-circle" /><span>{t('NFT元数据加载失败')}</span></div>}
            {!loading && !error && mediaType === 'image' && <img src={metadata.image} alt={metadata.name || `NFT #${token.id}`} onError={() => setMediaType('audio')} />}
            {!loading && !error && mediaType === 'audio' && <audio src={metadata.image} controls onClick={(event) => event.stopPropagation()} onError={() => setMediaType('video')}>{t('浏览器不支持音频')}</audio>}
            {!loading && !error && mediaType === 'video' && <video src={metadata.image} controls onClick={(event) => event.stopPropagation()} onError={() => setMediaType('unknown')}>{t('浏览器不支持视频')}</video>}
            {!loading && !error && mediaType === 'unknown' && <div className="nft-card__state"><i className="fa fa-file" /><span>{t('暂不支持此媒体类型')}</span></div>}
            <span className="nft-card__id">#{token.id}</span>
        </div>
        <div className="nft-card__body">
            <div>
                <strong>{metadata.name || `NFT #${token.id}`}</strong>
                {metadata.description && <small>{metadata.description}</small>}
            </div>
            <i className="fa fa-arrow-right nft-card__open" aria-hidden="true" />
        </div>
    </article>
}
